<template>
    <b-card class="mb-3">
        <div class="mx-0 mb-4 row">
            <h4>
                {{ $t('menu.createReport') }}
            </h4>
            <div class="ml-auto">
                <button type="button" class="close" @click="closeForm" :title="$t('general.cancel')">
                    <close-icon title="" />
                </button>
            </div>
        </div>
        <b-alert variant="danger" :show="showAlert">
            {{ alert }}
        </b-alert>
        <b-alert variant="success" :show="showSuccessAlert">
            {{ alert }}
        </b-alert>
        <b-form @submit.prevent="create">
            <b-form-group :label="$t('report.type')" label-cols-sm="3">
                <b-form-select :options="types" v-model="reportType" required></b-form-select>
            </b-form-group>
            <b-form-group :label="$t('kkm.label')" label-cols-sm="3">
                <multiselect v-model="ccm" 
                    :options="kkms" 
                    :internal-search="true" 
                    :placeholder="$t('general.enterValue')"
                    :select-label="''"
                    :showNoResults="false"
                    :allowEmpty="false"
                    label="factoryNumber">
                        <template slot="noOptions">
                            <span>
                                {{ $t('general.enterValue' )}}
                            </span>
                        </template>
                </multiselect>
            </b-form-group>
            <b-form-group :label="$t('report.fromDate')" label-cols-sm="3">
                <date-picker v-model="formData.fromDate" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" required></date-picker>
            </b-form-group>
            <b-form-group :label="$t('report.toDate')" label-cols-sm="3">
                <date-picker v-model="formData.tillDate" type="datetime" format="DD.MM.YYYY HH:mm:ss"
                    input-class="form-control" :clearable="false" confirm :first-day-of-week="1"
                    :lang="datePickerLocale" required></date-picker>
            </b-form-group>
            <b-form-row class="justify-content-end mx-0">
                <b-button type="button" variant="danger" @click="closeForm" :disabled="isDisabled" class="mr-2">
                    <close-icon title="" />&nbsp;{{ $t('general.cancel') }}
                </b-button>
                <b-button type="submit" variant="success" :disabled="!canCreate">
                    <plus-icon title="" />&nbsp;{{ $t('general.create') }}
                </b-button>
            </b-form-row>
        </b-form>
    </b-card>
</template>

<script>
/* eslin-disable */
import AppData from '@/utils/appdata';
import { normalizeArrayOfCcm } from '@/utils/utils';

export default {
    name: 'CreateReport',
    mixins: [ AppData ],
    props: {
        closeForm: Function,
        kkms: Array
    },
    data () {
        return {
            reportType: null,
            taxInspections: [],
            datePickerLocale: this.$store.getters.locale.toLowerCase(),
            formData: {
                fromDate: null,
                tillDate: null
            }, 
            ccm: null
        }
    },
    computed: {
        types() {
            return [
                { value: null, text: this.$t('general.select') },
                { value: this.$appConfig.apiUrls.report.createX, text: this.$t('report.types.REPORT_X') },
                { value: this.$appConfig.apiUrls.report.createPeriod, text: this.$t('report.types.FISCAL_PERIOD_REPORT') },
                { value: this.$appConfig.apiUrls.report.createCashier, text: this.$t('report.types.CASHIER_REPORT') },
                { value: this.$appConfig.apiUrls.report.createSection, text: this.$t('report.types.SECTION_REPORT') }
            ]
        },
        canCreate() {
            return !this.isDisabled 
                && this.ccm != null
                && this.formData.fromDate != null
                && this.formData.tillDate != null;
        }
    },
    methods: {
        create() {
            this.hideAlert();

            this.formData['ccm'] = this.ccm != null ? this.ccm.id : null;

            this.$request.sendRequest(this, this.reportType,
                this.formData, result => {
                    this.showSuccessAlert = true
                    this.alert = this.$i18n.t('report.createdMessage')
                }, this.displayAlert)
        }
    }
}
</script>
